// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"315":"2ab58766","400":"8c8b3f47","676":"fad43e6d","810":"59033dd1","828":"b14276b3"}[chunkId] + ".css";
};